import { isAdult } from "@/utils/profileUtilsTyped";
import { MemberProfileACPSection } from "@/components/Provider/PatientView/MemberProfile/MemberProfileACPSection/MemberProfileACPSection";
import MemberProfileConsentList from "@/components/Provider/PatientView/MemberProfile/MemberProfileConsentList";
import MemberProfilePolicyList from "@/components/Provider/PatientView/MemberProfile/MemberProfilePolicyList";
import { PatientProfile, UUID } from "@/core/types";
import { usePatientConsents } from "@/features/consent/api/queries/usePatientConsents";

import { MemberProfileConsentsSectionSkeleton } from "./MemberProfileConsentsSectionSkeleton";

type MemberProfileConsentsSectionProps = {
  dob?: PatientProfile["dob"];
  insuranceCarrier: string;
  patientId: UUID;
};

export function MemberProfileConsentsSection({
  dob,
  insuranceCarrier,
  patientId,
}: MemberProfileConsentsSectionProps) {
  const { data: consents, isLoading } = usePatientConsents({ patientId });
  const isPatientAdult = isAdult(dob);

  if (isLoading || !consents) return <MemberProfileConsentsSectionSkeleton />;

  return (
    <>
      {isPatientAdult && (
        <MemberProfileACPSection
          consents={consents}
          insuranceCarrier={insuranceCarrier}
          patientId={patientId}
        />
      )}
      <MemberProfilePolicyList consents={consents} patientId={patientId} />
      <MemberProfileConsentList consents={consents} patientId={patientId} />
    </>
  );
}
